export default "__VITE_ASSET__D6UGSWG0__"